/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterContextWidgetConfigurationModel extends models.BaseDataWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("FilterContextWidgetConfigurationModel");
    }

    getFixupPrototypeFunction() { return FilterContextWidgetConfigurationModel.fixupPrototype; }

    static newInstance(model: Partial<FilterContextWidgetConfigurationModel>): FilterContextWidgetConfigurationModel {
        let obj = Object.assign(new FilterContextWidgetConfigurationModel(), model);
        FilterContextWidgetConfigurationModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterContextWidgetConfigurationModel>): FilterContextWidgetConfigurationModel {
        if (!model) return null;
        return FilterContextWidgetConfigurationModel.newInstance(<FilterContextWidgetConfigurationModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterContextWidgetConfigurationModel) {
        if (!obj) return;

        models.FilterContextWidgetConfigurationModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterContextWidgetConfigurationModel): boolean {
        if (models.BaseDataWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FilterContextWidgetConfigurationModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
